import React from "react"
import TickerDropDown from "./tickerdropdown"
import ExpirySelector from "./expiryselector"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {OptionType} from "../data/options"

export default class ChainPicker extends React.Component {
    state = {
        selected_ticker: "KSS",
        selected_expiry: "",
        selected_option_type:OptionType.Call, 
    }

    expiryChanged = newExpiry => { this.setState({selected_expiry:newExpiry},()=>{this.notifyOfChainChange()}); }
    optionTypeChanged = event => { this.setState({selected_option_type:event.target.value},()=>{this.notifyOfChainChange()}); }
    tickerChanged = newTicker => { this.setState({selected_ticker:newTicker},()=>{this.notifyOfChainChange()}); }
   
    notifyOfChainChange() {
        const new_chain = {
            ticker: this.state.selected_ticker,
            expiry: this.state.selected_expiry,
            option_type: this.state.selected_option_type
        }
        this.props.onChainChanged(new_chain) //pass it up to container
    }

    componentDidMount() {
        this.setState({selected_ticker:this.props.defaultTicker})
    }
    render() {
        return (
        <table>
        <tbody>
          <tr>
              <td><TickerDropDown defaultTicker={this.props.defaultTicker}  onSelectedTickerChanged={this.tickerChanged} helperText="Select underlying company"/></td>
              <td><ExpirySelector ticker={this.state.selected_ticker} id="optionExpirySelector" onSelectedExpiryChange={this.expiryChanged} /></td>
              <td><RadioGroup  value={parseInt(this.state.selected_option_type)} onChange={this.optionTypeChanged} name="optionTypeSelector" id="optionTypeSelector">
                          <FormControlLabel  value={OptionType.Call} control={<Radio  />} label="Call"  />
                          <FormControlLabel value={OptionType.Put} control={<Radio />} label="Put" />
                          </RadioGroup>
                    </td>
            
          </tr>
        
      </tbody>
    </table>     
        ) 
    }
}